var ExcelController = (function () {
    function ExcelController($scope, $window, socket, env) {
        var _this = this;
        this.$scope = $scope;
        this.$window = $window;
        this.socket = socket;
        this.env = env;
        this.socket.forward('queue.exportQueue', this.$scope);
        this.$scope.$on('socket:queue.exportQueue', function (event, data) {
            _this.vm.isDownloading = false;
            if (!data.payload.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.payload], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }));
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                a.setAttribute('download', "DMT-" + _this.vm.queueLabel + "-Report_" + d + ".xlsx");
                a.click();
            }
        });
    }
    ExcelController.prototype.$onInit = function () {
        var data = {
            queryId: 'standardreport',
            filterTeams: this.vm.filterTeams,
            filterOwners: this.vm.filterOwners,
            filterSubStatuses: this.vm.filterSubStatuses,
            filterStatuses: this.vm.filterStatuses,
            filterSviStatuses: this.vm.filterSviStatuses,
            filterIots: this.vm.filterIots,
            filterImts: this.vm.filterImts,
            filterCountries: this.vm.filterCountries,
            vapFilter: this.vm.vapFilter
        };
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'exportQueue',
                script: 'queueservice/excelbuilder',
                data: {
                    filters: data,
                    userId: this.env.user.email
                },
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    ExcelController.$inject = ['$scope', '$window', 'socket', 'env'];
    return ExcelController;
}());
var ExcelComponent = (function () {
    function ExcelComponent() {
        this.bindings = { vm: '=' };
        this.templateUrl = 'excel-export.html';
        this.controller = ExcelController;
    }
    return ExcelComponent;
}());
angular
    .module('application')
    .component('downloadrSection', new ExcelComponent());

//# sourceMappingURL=excel.component.js.map
